import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './PetParentTag.module.scss';

interface PetParentTagProps {
    name: string;
    className?: string;
}

export const PetParentTag: FunctionComponent<PetParentTagProps> = props => {
    return <div className={clsx(styles.container, props.className)}>{props.name}</div>;
};

export default PetParentTag;
